export enum CarePlanTypeEnum {
    SafetyPlan = 1,
    BehavioralPlan = 2,
}
